import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from "ngx-infinite-scroll";//上拉下拉
import { FooterRefreshModule } from "../component/footer-refresh/footer-refresh.module";//加载和刷新
import { LazyLoadImageModule } from 'ng-lazyload-image';//图片懒加载
import { TicketListComponent } from '../ticketList/ticketList.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot([{ path: 'ticketList', component: TicketListComponent }]),
    InfiniteScrollModule,
    FooterRefreshModule,
    LazyLoadImageModule,
  ],
  declarations: [
    TicketListComponent
  ]
})
export class TicketListModule { }
